<!-- @format -->
<template>
    <div class="storefront-header-image-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Add a Header Image</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <span>
                    We recommend to uplaod an image that's at least <b>1264px</b> x <b>248px</b>.
                    Upload an image that pops and catches the viewers attention!</span
                >
                <div class="new-image-outer">
                    <div class="new-image-inner">
                        <storefront-header-image-upload
                            :agencyId="this.widget.options.agencyId"
                            v-model="image"
                            @uploading="handleUpload($event)"
                            @handle-image="handleImage($event)"
                            @delete="removeImage()"
                        />
                    </div>
                </div>
                <div class="replace-image-outer">
                    <div class="replace-image-inner"></div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-button" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="handleSave" :disabled="isUploading"> Save </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const StorefrontHeaderImageUpload = () =>
    import('@/components/storefront-header-image/storefront-header-image-upload');

import EventBus from '@/scripts/event-bus.js';
import { StorefrontService } from '@/scripts/services/storefront/StorefrontService';

export default {
    name: 'storefront-header-image-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'storefront-header-image-upload': StorefrontHeaderImageUpload,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isUploading: false,
            image: {
                name: null,
                url: null,
            },
        };
    },

    created() {
        this.query();
    },

    methods: {
        query() {
            return new Promise((resolve, reject) => {
                StorefrontService.getById(this.widget.options.agencyId)
                    .then((response) => {
                        this.populateStoreData(response);
                        resolve();
                    })
                    .catch((error) => {
                        this.$helpers.showFailNotification(
                            'An error occurred while fetching information.',
                            { error },
                        );
                        reject();
                    });
            });
        },

        populateStoreData(response) {
            const data = response.data.data;
            if (data.storefront[0].UpdatedAt) {
                this.image.url = data.storefront[0].HeaderImageUrl;
            }
            this.image.name = data.storefront[0].Name;
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        handleImage(item) {
            this.image = item;
        },

        removeImage() {
            this.image = null;
        },

        handleSave() {
            EventBus.$emit('storefront-banner-save', this.image);
            this.closeWidget();
        },

        handleUpload(isUploading) {
            this.isUploading = isUploading;
        },
    },
};
</script>

<style>
.storefront-header-image-widget .new-image-outer {
    border-radius: 21px;
    padding: 21px 18px;
    margin-top: 24px;
}
</style>
